import { array, partial } from 'io-ts/Decoder';

import * as user from '../../user';

export const Links = partial({
	users: array(user.Id),
});
